import { Fragment, useRef } from "react";
import Hero from "container/home/Hero";
import Trusted from "container/home/Trusted";
import Features from "container/home/Features";
import PricingPlan from "container/home/PricingPlan";
import Datacenter from "container/home/Datacenter";
import Testimonial from "container/home/Testimonial";
import Locations from "container/home/Locations";
import BuyProxies from "container/home/BuyProxies";
import PageLayouts from "layouts/PageLayouts";

const Homepage = () => {
    const homeRefs = useRef(null);
    return (
        <Fragment>
            <PageLayouts title="Proxy and SOCKS5" passHeroRefs={homeRefs}>
                <Hero refs={homeRefs} />
                <Trusted />
                <Features />
                <PricingPlan />
                <Datacenter />
                <Testimonial />
                <Locations />
                <BuyProxies />
            </PageLayouts>
        </Fragment>
    );
};

export default Homepage;